module.exports = __webpack_public_path__ + "94234efd60a3d0efefffa4b05da900bc.pdf";